import http from "../http-common-2";

class TherapyRequestService {
  getRequest(status:string) {
    return http.get(`/freesessionrequest?status=${status}`);
  }
  updateRequest(id:any,status:any) {
    return http.patch(`/freesessionrequest/${id}/status?status=${status}`);
  }
  updateCoupon(id:any,coupon:any) {
    return http.patch(`/freesessionrequest/${id}/coupon?coupon=${coupon}`);
  }
  updateUserList(id:any,userid:any) {
    return http.patch(`/coupon/${id}?userid=${userid}`);
  }
}
export default new TherapyRequestService();